/* ==========================================================================
   us-nav-height.js — publishes the sticky header's height as --us-nav-h.

   Any section that wants to fill the screen under the nav needs to subtract
   the nav, and the header is a separate section whose height changes with the
   announcement bar, the logo size and the breakpoint. Measuring beats a
   hardcoded number that silently goes stale.

   Loaded by the us-* sections that use the variable. Hoisting it into
   layout/theme.liquid would make it global and let the section tags go.
   ========================================================================== */
(function () {
  'use strict';
  function publish() {
    var nav = document.querySelector('.section-header, header[role="banner"]');
    if (!nav) return;
    var h = Math.round(nav.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--us-nav-h', h + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', publish);
  else publish();
  window.addEventListener('resize', publish);
  document.addEventListener('shopify:section:load', publish);
})();
